import axios from 'axios';

export const state = {
  client: null,
  application_client_id: null,
};

export const getters = {
  client: context => context.client,
  applicationClientId: context => context.application_client_id,
};

export const mutations = {
  setClient(context, client) {
    context.client = client;
  },
  setApplicationClientId(context, applicationClientId) {
    context.application_client_id = applicationClientId;
  },
};

export const actions = {
  async getClient(context) {
    return axios
      .get(`${window.BASE_API.PAYMENT}/api/client/${context.rootState.userStore.user.application_client_id}`)
      .then(response => context.commit('setClient', response.data))
      .catch(error => Promise.reject(error));
  },
  async storeName(context, data) {
    return axios
      .post(`${window.BASE_API.PAYMENT}/api/client/name`, {
        application_client_id: context.rootState.userStore.user.application_client_id,
        name: data.name,
      })
      .then(response => context.commit('setClient', response.data))
      .catch((error) => {
        const message = error.response.data.errors ?
          error.response.data.errors.name :
          error.response.data.message;
        throw new Error(message);
      });
  },
  async generateImportLink(context, data) {
    return axios
      .post(`${window.BASE_API.PAYMENT}/api/client/importLink/generate`, {
        application_client_id: context.rootState.userStore.user.application_client_id,
        master_password: data.master_password,
      })
      .then(response => response.data)
      .catch((error) => {
        const message = error.response.data.errors ?
          error.response.data.errors.master_password :
          error.response.data.message;
        throw new Error(message);
      });
  },
  async generateApiKey(context) {
    return axios
      .post(`${window.BASE_API.PAYMENT}/api/client/apiKey`, {
        application_client_id: context.rootState.userStore.user.application_client_id,
      })
      .then(response => context.commit('setClient', response.data))
      .catch((error) => {
        const message = error.response.data.errors ?
          error.response.data.errors.api_key :
          error.response.data.message;
        throw new Error(message);
      });
  },
  async storeMasterPassword(context, data) {
    return axios
      .post(`${window.BASE_API.PAYMENT}/api/client/masterPassword`, {
        application_client_id: context.rootState.userStore.user.application_client_id,
        master_password: data.master_password,
        password: data.password,
        repeat_password: data.repeat_password,
      })
      .then(response => context.commit('setClient', response.data))
      .catch(error => Promise.reject(error));
  },
};

const applicationClientStore = {
  state,
  mutations,
  getters,
  actions,
};

export default applicationClientStore;



// WEBPACK FOOTER //
// ./src/store/applicationClient/applicationClientStore.js